import { render } from "./SetCategoryWinnersPage.vue?vue&type=template&id=6c1542ba&scoped=true"
import script from "./SetCategoryWinnersPage.vue?vue&type=script&lang=js"
export * from "./SetCategoryWinnersPage.vue?vue&type=script&lang=js"

import "./SetCategoryWinnersPage.vue?vue&type=style&index=0&id=6c1542ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1542ba"]])

export default __exports__